export enum ShowTypingState {
	COMPOSING = 'composing',
	PAUSED = 'paused',
	CLEARED = 'cleared'
}
